import React from 'react';

const projects = [
  {
    title: '国家重点研发计划项目',
    description: '面向"双碳"目标的能源经济技术综合评估模型及决策支持系统研究',
    period: '2022-2025',
    status: '在研',
    category: '国家级项目'
  },
  {
    title: '国家自然科学基金重点项目',
    description: '中国能源系统低碳转型的技术经济性评估与情景分析',
    period: '2021-2024',
    status: '在研',
    category: '国家级项目'
  }
];

export default function Projects() {
  return (
    <div className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">科研项目</h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            待修正
          </p>
        </div>
        <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-8 sm:mt-16 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          {projects.map((project) => (
            <div key={project.title} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                  {project.category}
                </span>
                <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${
                  project.status === '在研' ? 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/20' : 'bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10'
                }`}>
                  {project.status}
                </span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900">{project.title}</h3>
              <p className="mt-2 text-gray-600">{project.description}</p>
              <div className="mt-4 flex items-center text-sm text-gray-500">
                <svg className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                </svg>
                <span>执行期：{project.period}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}